import { FaPlus, FaMinus } from "react-icons/fa";

export default function GuestSelector({
  visitors,
  incrementVisitor,
  decrementVisitor,
  maxCapacity = 99,
}) {
  const total = visitors?.reduce((sum, v) => sum + (v.count || 0), 0) ?? 0;

  return (
    <div className="space-y-3">
      <div className="flex items-center justify-between">
        <span className="text-sm font-medium text-gray-700">Guests</span>
        <span className="text-sm text-gray-500">{total} / {maxCapacity}</span>
      </div>
      {visitors?.map((v) => (
        <div
          key={v.typeId}
          className="flex items-center justify-between p-3 border border-gray-200 rounded-xl bg-gray-50/50"
        >
          <div>
            <div className="font-medium text-gray-900">{v.type}</div>
            <div className="text-xs text-gray-500">{v.minAge}-{v.maxAge} years</div>
          </div>
          <div className="flex items-center gap-2">
            <button
              type="button"
              onClick={() => decrementVisitor(v.typeId)}
              disabled={v.count === 0}
              className="w-8 h-8 rounded-full border border-gray-300 flex items-center justify-center hover:bg-gray-200 disabled:opacity-40"
            >
              <FaMinus className="text-xs" />
            </button>
            <span className="w-8 text-center font-semibold">{v.count}</span>
            <button
              type="button"
              onClick={() => incrementVisitor(v.typeId)}
              disabled={total >= maxCapacity}
              className="w-8 h-8 rounded-full bg-[#1ABCE3] text-white flex items-center justify-center hover:opacity-90 disabled:opacity-40"
            >
              <FaPlus className="text-xs" />
            </button>
          </div>
        </div>
      ))}
    </div>
  );
}
